import { CodeAndLabel, ProviderCode } from "../../../integrated-client/models";
import { IIdentity, Identity } from "../ShoppingDiagnostics/FormData";

export interface IBookingFormData {
  bookingRef: string | null;
  providerCode: ProviderCode | null;
  identity: IIdentity;
  validation?: any;
}

export class BookingFormData implements IBookingFormData {
  bookingRef: string | null;
  providerCode: ProviderCode | null;
  identity: IIdentity;
  validation?: any;

  constructor(salesJourney?: CodeAndLabel | null) {
    this.bookingRef = null;
    this.providerCode = null;
    this.identity = new Identity(salesJourney);
  }
}
